import Cookie from 'js-cookie';
import { LocationUtilities, SiteUtilities } from '../utils';
import GA4Utilities from '../utils/ga4-utilities';
import fwcrmFormHandlers from './fwcrm-form-handlers';

var fcallerSignupForm = function (classname, form) {
  const $form = $(form);
  const email = $form.find('input[name^="email"]').val();
  const currentLocation = SiteUtilities.getCurrentLocation();
  const currentReferrer = SiteUtilities.getCurrentReferrer();
  const geoLocation = LocationUtilities.getGeoLocation();
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  const signUpApiUrl = $form.data('signup-url') || 'https://signup.freshcaller.com/accounts';
  const remindEndPoint = $form.data('remind-path') || 'https://signup.freshcaller.com/find_domain?user_email=';
  const firstName = $form.find('.first-name-form').val();
  const lastName = $form.find('.last-name-form').val();
  const phoneNumber = $form.find('.phone-form').val();
  const companyName = $form.find('.company-form').val();
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;

  const fmAssetId = $form.find('.fm-asset-id').val() || $form.data('fm_asset_id') || 3649313;
  const tacticId = SiteUtilities.getTacticID() || '';
  const compositeKey = SiteUtilities.getCompositeKey(email, fmAssetId, tacticId);

  const sessionObj = window.session ? JSON.parse(JSON.stringify(window.session)) : {};
  if (sessionObj) {
    sessionObj.composite_stitching_key = compositeKey;
    sessionObj.allocadia_asset_id = fmAssetId;
    sessionObj.allocadia_tactic_id = tacticId;

    sessionObj.ga_client_id = `${SiteUtilities.getGAClientID()}:${compositeKey}`;
  }

  const data = {
    signup: {
      user_email: '' + email,
      gdpr_first_opt_in: $form.find('input[name="send_promotions"]').is(':checked'),
      time_zone: '' + sessionObj.time.tz_offset,
      first_referrer: (isExternalIframeSignup && currentReferrer) ? currentReferrer : (Cookie.get('fw_fr') || currentLocation),
      first_landing_url: (Cookie.get('fw_flu') || ''),
      landing_url: (Cookie.get('fw_fr') || currentLocation),
      user_first_name: firstName,
      user_last_name: lastName,
      user_phone: phoneNumber,
      user_company: companyName,
      user_name: firstName + ' ' + lastName
    },
    gdpr_first_opt_in: $form.find('input[name="send_promotions"]').is(':checked'),
    session_json: sessionObj || '',
    first_referrer: (isExternalIframeSignup && currentReferrer) ? currentReferrer : (Cookie.get('fw_fr') || currentLocation),
    first_landing_url: (Cookie.get('fw_flu') || ''),
    pre_visits: Cookie.get('fw_vi') || 0,
    source: SiteUtilities.getParameterByName('utm_source'),
    medium: SiteUtilities.getParameterByName('utm_medium'),
    campaign: SiteUtilities.getParameterByName('utm_campaign'),
    fs_cookie: freshsales.anonymous_id || 'Not found'
  };

  if (SiteUtilities.GDPRFunctionalCookieDisabled()) {
    data.signup['country'] = geoLocation ? geoLocation.countryName : '';
    data['country'] = geoLocation ? geoLocation.countryName : '';
  } else {
    data.signup['city'] = geoLocation ? geoLocation.cityName : '';
    data.signup['continent'] = geoLocation ? geoLocation.continentName : '';
    data.signup['country'] = geoLocation ? geoLocation.countryName : '';
    data['country'] = geoLocation ? geoLocation.countryName : '';
    data.signup['zipcode'] = geoLocation ? geoLocation.zipCode : '';
  }

  $.ajax({
    url: signUpApiUrl,
    type: 'POST',
    headers: { 'Access-Control-Allow-Origin': '*' },
    data: JSON.stringify(data),
    accept: 'application/json; charset=UTF-8',
    contentType: 'application/json; charset=UTF-8',
    dataType: 'json',
    success: (response) => {
      if (response.success && response.url) {
        response.composite_stitching_key = compositeKey;
        fcallerSignupFormSuccess($form, response);
      }
    },
    error: (xhr, status, err) => {
      if (xhr.responseText.includes('multiple_signup_detected')) {
        $('.login-trigger-button.fcaller').trigger('click');
        $form.find('.button').removeClass('button--loading').removeAttr('disabled');
        $('.email-reminder-button').on('click', function () {
          $.ajax({
            url: remindEndPoint + encodeURIComponent(email),
            type: 'GET',
            success: (response) => {
              $('.form-field-container,.thank-you-card').addClass('active');
              $('.thank-you-card').addClass('small-card');
            }
          });
        });
      } else if (xhr.responseText.includes('spam_email')) {
        $('.login-spam-trigger-button.fcaller').trigger('click');
        $form.find('button').removeClass('button--loading').removeAttr('disabled');
      }
    },
    complete: () => {
      $form.find('.button').removeClass('button--loading').attr('disabled', null);
    }
  });
};

const fcallerSignupFormSuccess = ($form, response, alohaV2 = false) => {
  const redirectFid = $form.data('redirect-fid');
  const redirect = $form.data('redirect');
  const email = $form.find('input[name^="email"]').val();
  const emailHash = SiteUtilities.getShaHash(email);
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();
  const geoLocation = LocationUtilities.getGeoLocation();
  SiteUtilities.configureAssetId($form, 'fcaller');
  let redirectUrl;
  let accountId = '';
  if (alohaV2) {
    const signupResponse = response['product_signup_response'];
    redirectUrl = signupResponse['redirect_url'].replace(/\/$/, '');
    accountId = (signupResponse.account && signupResponse.account.id) ? signupResponse.account.id : '';
  } else {
    redirectUrl = response.url;
  }

  // Freshmarketer Data. We are passing email, contactable. Other fields will be sent by the product endpoint.
  const freshmarketerData = {
    freshmarketerObject: {
      email: email,
      country: geoLocation ? geoLocation.countryName : '',
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_freshmarketer_list: $form.find('.fm-list-id').val() || ''
      },
      domainUrl: redirectUrl,
      product: 'Freshcaller',
      accountId: accountId,
      composite_stitching_key: response.composite_stitching_key || null
    }
  };

  GA4Utilities.ga4ThankYouEvent(accountId, redirectUrl, $form);
  SiteUtilities.passSignupResponseToGA(accountId, redirectUrl, 'Freshcaller');
  SiteUtilities.freshmarketerPost(freshmarketerData, true, $form);
  $('body').on('freshmarketerPostCompleted', () => {
    localStorage.setItem('fmarketerEndTime', new Date().toISOString());
    localStorage.setItem('redirect_url', redirectUrl);
    let thankYouRedirect;
    if (response.freshid_activated && response.freshid_activated === true) {
      const signupDomain = redirectUrl.split('.freshcaller.com')[0].replace(/(^\w+:|^)\/\//, '');
      localStorage.setItem('fw-fid-domain', signupDomain);
      thankYouRedirect = `${redirectFid}/?redirect=` + encodeURIComponent(redirectUrl) + `&ehash=${emailHash}`;
    } else {
      thankYouRedirect = `${redirect}/?redirect=` + encodeURIComponent(redirectUrl) + `&ehash=${emailHash}`;
    }
    if (isExternalIframeSignup) {
      thankYouRedirect += '&post_to_partner=true';
      if (currentReferrer) {
        thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
      }
    }
    localStorage.setItem('thankyouRedirectStartTime', new Date().toISOString());
    window.location.href = thankYouRedirect;
  });
};

var fcallerLoginForm = function (classname, form) {
  const $form = $(form);
  const domain = $form.find('.domain-form').val();
  const subdomainProduct = $form.find('.subdomain-product').val();
  if (!domain || !subdomainProduct) return;

  if (['.myfreshworks.com', '.freshworks.com'].includes(subdomainProduct)) {
    fwcrmFormHandlers.fwcrmLoginForm(classname, form);
  } else {
    const loginUrl = $form.data('login-url') || 'https://signup.freshcaller.com/domain_available?domain=';
    $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
    jQuery.getJSON(loginUrl + domain, function (data) {
      if (data.is_available === false) {
        window.location.href = `https://${domain}.freshcaller.com`;
      } else {
        $form.find('.button').removeClass('button--loading').removeAttr('disabled');
        $form.find('.email-form').parents('.form-field').addClass('error');
        $form.find('.error-wrapper').append("<em class='error'>This account does not exist</em>");
        $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      }
    });
  }
  GA4Utilities.loginFormSubmit(domain);
};

var fcallerForgotDomainForm = function (classname, form) {
  const $form = $(form);
  const email = $form.find('.email-form').val();
  const forgotDomainUrl = $form.data('forgot-domain-url') || 'https://signup.freshcaller.com/find_domain?user_email=';
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  $.ajax({
    url: forgotDomainUrl + encodeURIComponent(email),
    type: 'GET',
    success: (response) => {
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      jQuery('.form-wrapper', '.forgot-domain-form-wrapper').slideUp(300);
      setTimeout(function () {
        jQuery('.forgot-domain-success').slideDown(300);
      }, 300);
    },
    error: (xhr, status, err) => {
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      $form.find('.email-form').parents('.form-field').addClass('error');
      $form.find('.error-wrapper').empty().append("<em class='error'>This email does not exist</em>");
    }
  });
};

export default {
  fcallerSignupForm,
  fcallerLoginForm,
  fcallerForgotDomainForm,
  fcallerSignupFormSuccess
};
